module.exports = __webpack_public_path__ + "static/media/  (171).17b50e92.jpg";